/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.genotype_cif_scd = void 0;
let genotype_cif_scd = [
    {
        idx: 1,
        day: 1,
        day_prev_evt: 0,
        hazard0_scd: 0.00085866032815686206,
        surv0_prev: 1,
        cif0_scd: 0.00085866032815686206,
        cumhaz0_scd: 0.00085866032815686206,
        cumhaz0_oth: 0,
    },
    {
        idx: 2,
        day: 2,
        day_prev_evt: 1,
        hazard0_scd: 0,
        surv0_prev: 0.99914133967184315,
        cif0_scd: 0.00085866032815686206,
        cumhaz0_scd: 0.00085866032815686206,
        cumhaz0_oth: 9.341033177538588e-6,
    },
    {
        idx: 3,
        day: 9,
        day_prev_evt: 2,
        hazard0_scd: 0.00087754589002571662,
        surv0_prev: 0.99913200665944024,
        cif0_scd: 0.0017354445141940008,
        cumhaz0_scd: 0.0017362062181825787,
        cumhaz0_oth: 9.341033177538588e-6,
    },
    {
        idx: 4,
        day: 10,
        day_prev_evt: 9,
        hazard0_scd: 0.00089161910526891085,
        surv0_prev: 0.99825522247340304,
        cif0_scd: 0.002625507942485754,
        cumhaz0_scd: 0.0026278253234514894,
        cumhaz0_oth: 9.341033177538588e-6,
    },
    {
        idx: 5,
        day: 18,
        day_prev_evt: 10,
        hazard0_scd: 0.00092544902026700168,
        surv0_prev: 0.99736515904511136,
        cif0_scd: 0.0035485185517724945,
        cumhaz0_scd: 0.0035532743437184911,
        cumhaz0_oth: 9.341033177538588e-6,
    },
    {
        idx: 6,
        day: 30,
        day_prev_evt: 18,
        hazard0_scd: 0.00094080890628173218,
        surv0_prev: 0.99644214843582457,
        cif0_scd: 0.0044859801996154219,
        cumhaz0_scd: 0.0044940832500002231,
        cumhaz0_oth: 9.341033177538588e-6,
    },
    {
        idx: 7,
        day: 36,
        day_prev_evt: 30,
        hazard0_scd: 0.00094541836687532901,
        surv0_prev: 0.99550468678798165,
        cif0_scd: 0.0054271486148152514,
        cumhaz0_scd: 0.0054395016168755517,
        cumhaz0_oth: 9.341033177538588e-6,
    },
    {
        idx: 8,
        day: 38,
        day_prev_evt: 36,
        hazard0_scd: 0.0009458930845585023,
        surv0_prev: 0.99456351837278179,
        cif0_scd: 0.0063678993689982389,
        cumhaz0_scd: 0.006385394701434054,
        cumhaz0_oth: 9.341033177538588e-6,
    },
    {
        idx: 9,
        day: 43,
        day_prev_evt: 38,
        hazard0_scd: 0.00095686464968055304,
        surv0_prev: 0.9936227676185988,
        cif0_scd: 0.0073186618704502307,
        cumhaz0_scd: 0.0073422593511146073,
        cumhaz0_oth: 9.341033177538588e-6,
    },
    {
        idx: 10,
        day: 60,
        day_prev_evt: 43,
        hazard0_scd: 0.00097597860784877561,
        surv0_prev: 0.99267200511714682,
        cif0_scd: 0.0082874885120549167,
        cumhaz0_scd: 0.0083182379589633836,
        cumhaz0_oth: 9.341033177538588e-6,
    },
    {
        idx: 11,
        day: 67,
        day_prev_evt: 60,
        hazard0_scd: 0.00098035887799076513,
        surv0_prev: 0.99170317847554212,
        cif0_scd: 0.0092597135274050738,
        cumhaz0_scd: 0.0092985968369541493,
        cumhaz0_oth: 9.341033177538588e-6,
    },
    {
        idx: 12,
        day: 105,
        day_prev_evt: 67,
        hazard0_scd: 0.0011236910688447771,
        surv0_prev: 0.99073095346019191,
        cif0_scd: 0.010372989051436363,
        cumhaz0_scd: 0.010422287905798926,
        cumhaz0_oth: 9.341033177538588e-6,
    },
    {
        idx: 13,
        day: 147,
        day_prev_evt: 105,
        hazard0_scd: 0,
        surv0_prev: 0.98961767793616062,
        cif0_scd: 0.010372989051436363,
        cumhaz0_scd: 0.010422287905798926,
        cumhaz0_oth: 2.0055142557807993e-5,
    },
    {
        idx: 14,
        day: 148,
        day_prev_evt: 147,
        hazard0_scd: 0,
        surv0_prev: 0.98960707506411461,
        cif0_scd: 0.010372989051436363,
        cumhaz0_scd: 0.010422287905798926,
        cumhaz0_oth: 3.0782825178681222e-5,
    },
    {
        idx: 15,
        day: 155,
        day_prev_evt: 148,
        hazard0_scd: 0,
        surv0_prev: 0.9895964588734939,
        cif0_scd: 0.010372989051436363,
        cumhaz0_scd: 0.010422287905798926,
        cumhaz0_oth: 4.1665279129259625e-5,
    },
    {
        idx: 16,
        day: 162,
        day_prev_evt: 155,
        hazard0_scd: 0,
        surv0_prev: 0.98958568963560067,
        cif0_scd: 0.010372989051436363,
        cumhaz0_scd: 0.010422287905798926,
        cumhaz0_oth: 5.2801435566229743e-5,
    },
    {
        idx: 17,
        day: 190,
        day_prev_evt: 162,
        hazard0_scd: 0.0011799479356477522,
        surv0_prev: 0.98957466945455308,
        cif0_scd: 0.011540635639828569,
        cumhaz0_scd: 0.011602235841446679,
        cumhaz0_oth: 5.2801435566229743e-5,
    },
    {
        idx: 18,
        day: 213,
        day_prev_evt: 190,
        hazard0_scd: 0.0012115692442531971,
        surv0_prev: 0.98840702286616078,
        cif0_scd: 0.012738159189537076,
        cumhaz0_scd: 0.012813805085699875,
        cumhaz0_oth: 5.2801435566229743e-5,
    },
    {
        idx: 19,
        day: 316,
        day_prev_evt: 213,
        hazard0_scd: 0.0013170704035664125,
        surv0_prev: 0.9872094993164523,
        cif0_scd: 0.014038383603206393,
        cumhaz0_scd: 0.014130875489266288,
        cumhaz0_oth: 5.2801435566229743e-5,
    },
    {
        idx: 20,
        day: 319,
        day_prev_evt: 316,
        hazard0_scd: 0.0013220518840424541,
        surv0_prev: 0.98590927490278302,
        cif0_scd: 0.015341806817586547,
        cumhaz0_scd: 0.015452927373308743,
        cumhaz0_oth: 5.2801435566229743e-5,
    },
    {
        idx: 21,
        day: 370,
        day_prev_evt: 319,
        hazard0_scd: 0.0013565091193994366,
        surv0_prev: 0.98460585168840287,
        cif0_scd: 0.016677433634415914,
        cumhaz0_scd: 0.01680943649270818,
        cumhaz0_oth: 5.2801435566229743e-5,
    },
    {
        idx: 22,
        day: 372,
        day_prev_evt: 370,
        hazard0_scd: 0,
        surv0_prev: 0.98327022487157345,
        cif0_scd: 0.016677433634415914,
        cumhaz0_scd: 0.01680943649270818,
        cumhaz0_oth: 6.5690202969835644e-5,
    },
    {
        idx: 23,
        day: 406,
        day_prev_evt: 372,
        hazard0_scd: 0.0013785198828266789,
        surv0_prev: 0.98325755173035023,
        cif0_scd: 0.018032873719415685,
        cumhaz0_scd: 0.018187956375534858,
        cumhaz0_oth: 6.5690202969835644e-5,
    },
    {
        idx: 24,
        day: 422,
        day_prev_evt: 406,
        hazard0_scd: 0.0013869812602269717,
        surv0_prev: 0.98190211164535046,
        cif0_scd: 0.019394753547645076,
        cumhaz0_scd: 0.019574937635761829,
        cumhaz0_oth: 6.5690202969835644e-5,
    },
    {
        idx: 25,
        day: 447,
        day_prev_evt: 422,
        hazard0_scd: 0,
        surv0_prev: 0.98054023181712113,
        cif0_scd: 0.019394753547645076,
        cumhaz0_scd: 0.019574937635761829,
        cumhaz0_oth: 8.0064893329423521e-5,
    },
    {
        idx: 26,
        day: 471,
        day_prev_evt: 447,
        hazard0_scd: 0,
        surv0_prev: 0.98052613685490364,
        cif0_scd: 0.019394753547645076,
        cumhaz0_scd: 0.019574937635761829,
        cumhaz0_oth: 9.4978832789226344e-5,
    },
    {
        idx: 27,
        day: 503,
        day_prev_evt: 471,
        hazard0_scd: 0.0014265544458127602,
        surv0_prev: 0.98051151334745978,
        cif0_scd: 0.020793506606181494,
        cumhaz0_scd: 0.021001492081574591,
        cumhaz0_oth: 9.4978832789226344e-5,
    },
    {
        idx: 28,
        day: 517,
        day_prev_evt: 503,
        hazard0_scd: 0.0014437430054563458,
        surv0_prev: 0.97911276028892336,
        cif0_scd: 0.02220709380540168,
        cumhaz0_scd: 0.022445235087030935,
        cumhaz0_oth: 9.4978832789226344e-5,
    },
    {
        idx: 29,
        day: 536,
        day_prev_evt: 517,
        hazard0_scd: 0,
        surv0_prev: 0.97769917308970322,
        cif0_scd: 0.02220709380540168,
        cumhaz0_scd: 0.022445235087030935,
        cumhaz0_oth: 0.00011035522947862124,
    },
    {
        idx: 30,
        day: 560,
        day_prev_evt: 536,
        hazard0_scd: 0.0015196134105925165,
        surv0_prev: 0.97768413959937484,
        cif0_scd: 0.023692795735260497,
        cumhaz0_scd: 0.023964848497623453,
        cumhaz0_oth: 0.00011035522947862124,
    },
    {
        idx: 31,
        day: 597,
        day_prev_evt: 560,
        hazard0_scd: 0.0016582941068662355,
        surv0_prev: 0.97619843766951608,
        cif0_scd: 0.025311619851579883,
        cumhaz0_scd: 0.025623142604489689,
        cumhaz0_oth: 0.00011035522947862124,
    },
    {
        idx: 32,
        day: 606,
        day_prev_evt: 597,
        hazard0_scd: 0.0016615107972562937,
        surv0_prev: 0.97457961355319667,
        cif0_scd: 0.026930894402284383,
        cumhaz0_scd: 0.027284653401745983,
        cumhaz0_oth: 0.00011035522947862124,
    },
    {
        idx: 33,
        day: 655,
        day_prev_evt: 606,
        hazard0_scd: 0.0017024341708149048,
        surv0_prev: 0.97296033900249224,
        cif0_scd: 0.028587295330249882,
        cumhaz0_scd: 0.028987087572560889,
        cumhaz0_oth: 0.00011035522947862124,
    },
    {
        idx: 34,
        day: 666,
        day_prev_evt: 655,
        hazard0_scd: 0.0017468896456341127,
        surv0_prev: 0.97130393807452664,
        cif0_scd: 0.030284056122435909,
        cumhaz0_scd: 0.030733977218195003,
        cumhaz0_oth: 0.00011035522947862124,
    },
    {
        idx: 35,
        day: 674,
        day_prev_evt: 666,
        hazard0_scd: 0.0017526118502129955,
        surv0_prev: 0.96960717728234069,
        cif0_scd: 0.031983401151392511,
        cumhaz0_scd: 0.032486589068407998,
        cumhaz0_oth: 0.00011035522947862124,
    },
    {
        idx: 36,
        day: 804,
        day_prev_evt: 674,
        hazard0_scd: 0.0019084132007811082,
        surv0_prev: 0.96790783225338406,
        cif0_scd: 0.033830569235604298,
        cumhaz0_scd: 0.034395002269189109,
        cumhaz0_oth: 0.00011035522947862124,
    },
    {
        idx: 37,
        day: 819,
        day_prev_evt: 804,
        hazard0_scd: 0.0019463559491782745,
        surv0_prev: 0.96606066416917225,
        cif0_scd: 0.035710867156577078,
        cumhaz0_scd: 0.036341358218367384,
        cumhaz0_oth: 0.00011035522947862124,
    },
    {
        idx: 38,
        day: 876,
        day_prev_evt: 819,
        hazard0_scd: 0.0040261285059291687,
        surv0_prev: 0.96418036624819947,
        cif0_scd: 0.039592781213986183,
        cumhaz0_scd: 0.040367486724296554,
        cumhaz0_oth: 0.00011035522947862124,
    },
    {
        idx: 39,
        day: 950,
        day_prev_evt: 876,
        hazard0_scd: 0.0020594118146593614,
        surv0_prev: 0.96029845219079035,
        cif0_scd: 0.041570431192026996,
        cumhaz0_scd: 0.042426898538955912,
        cumhaz0_oth: 0.00011035522947862124,
    },
    {
        idx: 40,
        day: 982,
        day_prev_evt: 950,
        hazard0_scd: 0.0020738135588832603,
        surv0_prev: 0.9583208022127494,
        cif0_scd: 0.04355780986541568,
        cumhaz0_scd: 0.044500712097839172,
        cumhaz0_oth: 0.00011035522947862124,
    },
    {
        idx: 41,
        day: 990,
        day_prev_evt: 982,
        hazard0_scd: 0.0020818606026016709,
        surv0_prev: 0.95633342353936079,
        cif0_scd: 0.045548762742833447,
        cumhaz0_scd: 0.04658257270044084,
        cumhaz0_oth: 0.00011035522947862124,
    },
    {
        idx: 42,
        day: 1102,
        day_prev_evt: 990,
        hazard0_scd: 0.0023015725697145459,
        surv0_prev: 0.954342470661943,
        cif0_scd: 0.047745251195422583,
        cumhaz0_scd: 0.048884145270155388,
        cumhaz0_oth: 0.00011035522947862124,
    },
    {
        idx: 43,
        day: 1123,
        day_prev_evt: 1102,
        hazard0_scd: 0.0023109788757970668,
        surv0_prev: 0.95214598220935398,
        cif0_scd: 0.04994564044698345,
        cumhaz0_scd: 0.051195124145952453,
        cumhaz0_oth: 0.00011035522947862124,
    },
    {
        idx: 44,
        day: 1243,
        day_prev_evt: 1123,
        hazard0_scd: 0.0024705588059381824,
        surv0_prev: 0.94994559295779302,
        cif0_scd: 0.052292536896827495,
        cumhaz0_scd: 0.053665682951890635,
        cumhaz0_oth: 0.00011035522947862124,
    },
    {
        idx: 45,
        day: 1439,
        day_prev_evt: 1243,
        hazard0_scd: 0.0027988873827550901,
        surv0_prev: 0.94759869650794903,
        cif0_scd: 0.054944758932398766,
        cumhaz0_scd: 0.056464570334645726,
        cumhaz0_oth: 0.00011035522947862124,
    },
    {
        idx: 46,
        day: 1630,
        day_prev_evt: 1439,
        hazard0_scd: 0.0030031510004927863,
        surv0_prev: 0.94494647447237767,
        cif0_scd: 0.057782575882622617,
        cumhaz0_scd: 0.059467721335138515,
        cumhaz0_oth: 0.00011035522947862124,
    },
    {
        idx: 47,
        day: 1806,
        day_prev_evt: 1630,
        hazard0_scd: 0.0035514213195051033,
        surv0_prev: 0.94210865752215389,
        cif0_scd: 0.061128400654237122,
        cumhaz0_scd: 0.063019142654643617,
        cumhaz0_oth: 0.00011035522947862124,
    },
];
exports.genotype_cif_scd = genotype_cif_scd;



// WEBPACK FOOTER //
// ./demo/pages/components/primacy-cal-js/genotype_baseline_hazard.js